import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import TextField from 'components/fields/TextField';

const NarrativeCreateEditForm = ({ handleSubmit, className }) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
  >
    <Grid
      container
      justify="center"
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Narrative"
          name="Narrative"
          placeholder="Leave your narrative"
          component={TextField}
          fullWidth
          multiline
          rows={10}
          maxLength="100"
        />
      </Grid>
    </Grid>
  </form>
);

NarrativeCreateEditForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  className: PropTypes.string,
};

NarrativeCreateEditForm.defaultProps = {
  className: '',
};

export default reduxForm()(NarrativeCreateEditForm);



// WEBPACK FOOTER //
// ./src/components/workflow/NarrativeCreateEditDialog/NarrativeCreateEditForm.js